<template>
  <v-card flat>
    <v-row class="my-2" align="center" justify="center">
      <v-col
        cols="3"
        v-if="provideQrCode && showQrCode && qrCode"
        align="center"
        justify="center"
      >
        <v-row dense>
          <v-col cols="12">
            <qr-code :text="qrCode" :size="120" error-level="L" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <span class="text-caption">{{ $t("qr code info") }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn
              text
              small
              :loading="refreshingQrCode"
              :disabled="refreshingQrCode"
              @click="refreshQrCode()"
            >
              {{ $t("refresh qr code") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col :cols="showQrCode ? 9 : 12">
        <v-simple-table dense>
          <tbody>
            <tr>
              <th>{{ $t("national number") }}</th>
              <td>{{ item.national_number }}</td>
            </tr>
            <tr>
              <th>{{ $t("international number") }}</th>
              <td>{{ item.number }}</td>
            </tr>
            <tr v-if="item.display_name">
              <th>{{ $t("display name") }}</th>
              <td>{{ item.display_name ? item.display_name : "-" }}</td>
            </tr>
            <tr v-if="item.language">
              <th>{{ $t("language") }}</th>
              <td>{{ item.language }}</td>
            </tr>
            <tr>
              <th>{{ $t("is main") }}</th>
              <td>
                <boolean-value :value="item.is_main" />
              </td>
            </tr>
            <tr v-if="item.signaling_only">
              <th>{{ $t("signaling only") }}</th>
              <td>
                <boolean-value :value="item.signaling_only" color />
              </td>
            </tr>
            <tr>
              <th>{{ $t("premium number") }}</th>
              <td>
                <boolean-value :value="item.premium_number" />
              </td>
            </tr>
            <tr v-if="item.premium_number_class">
              <th>{{ $t("premium number class") }}</th>
              <td>{{ item.premium_number_class }}</td>
            </tr>
            <tr v-if="item.block_size > 1">
              <th>{{ $t("block size") }}</th>
              <td>{{ item.block_size }}</td>
            </tr>
            <tr v-if="provideQrCode">
              <th>{{ $t("qr code") }}</th>
              <td>
                <v-btn
                  :disabled="loadingQrCode && !qrCode"
                  :loading="loadingQrCode"
                  @click="showQrCode = !showQrCode"
                  small
                  icon
                >
                  <v-icon>mdi-qrcode</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>

    <!--
    <v-row>
      <v-col cols="12">
        <v-card-title>{{ $t("top stop") }}</v-card-title>
        <top-stop :value="item.top_stop || {}" />
      </v-col>
    </v-row>
    -->

    <!--
    <v-row>
      <v-col cols="12">
        <v-card-title>{{ $t("emergency contact") }}</v-card-title>
        <emergency-contact :value="item.emergency_contact || {}" />
      </v-col>
    </v-row>
    -->

    <!--
    <v-row>
      <v-col cols="12">
        <v-card-title>{{ $t("SIP registrations") }}</v-card-title>
        <v-card
          v-for="(reg, key) in item.sip_registrations || []"
          :key="key"
          disabled
          flat
        >
          <sip-registration :value="reg" />
        </v-card>
        <v-card
          v-if="!item.sip_registrations || !item.sip_registrations.length > 0"
          disabled
          flat
        >
          <v-card-text>
            {{ $t("no SIP registrations") }}
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    -->
  </v-card>
</template>

<script>
import formatDate from "@/utils/mixins/formatDate";
import formatMoney from "@/utils/mixins/formatMoney";
import formatNumber from "@/utils/mixins/formatNumber";
import formatPhoneNumber from "@/utils/mixins/formatPhoneNumber";
import showErrors from "@/utils/mixins/showErrors";
import isMobile from "@/utils/mixins/isMobile";
import BooleanValue from "@/components/basics/BooleanValue";
import TopStop from "@/components/services/voip/TopStop";
import CallForward from "@/components/services/voip/CallForward";
import EmergencyContact from "@/components/services/voip/EmergencyContact";
import SipRegistration from "@/components/services/voip/SipRegistration";

export default {
  name: "Number",
  mixins: [
    formatDate,
    formatMoney,
    formatNumber,
    formatPhoneNumber,
    showErrors,
    isMobile,
  ],
  components: {
    BooleanValue,
    TopStop,
    CallForward,
    EmergencyContact,
    SipRegistration,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    productId: {
      validator: (prop) => typeof prop === "string" || typeof prop === "number",
    },
    provideQrCode: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    item: null,
    showQrCode: false,
    qrCode: null,
    loadingItem: false,
    loadingQrCode: false,
    refreshingQrCode: false,
  }),
  watch: {
    value: {
      immediate: true,
      handler(value) {
        if (value) {
          this.item = { ...value };
          if (value.id) {
            this.getItem();
            if (this.provideQrCode) this.getQrCode();
          }
        }
      },
    },
  },
  methods: {
    getItem() {
      var that = this;
      that.loadingItem = true;
      this.$http
        .get("services/voip/" + this.productId + "/numbers/" + this.value.id)
        .then((response) => {
          that.item = { ...response.data };
        })
        .catch((err) => {
          that.$store.commit("setSystemError", {
            msg: err.message,
            title: err.title,
          });
        })
        .finally(function () {
          that.loadingItem = false;
        });
    },
    getQrCode() {
      var that = this;
      that.loadingQrCode = true;
      this.$http
        .get(
          "services/voip/" +
            this.productId +
            "/numbers/" +
            this.value.id +
            "/qr-code"
        )
        .then((response) => {
          that.qrCode = response.data.code;
        })
        .catch((err) => {
          that.$store.commit("setSystemError", {
            msg: err.message,
            title: err.title,
          });
        })
        .finally(function () {
          that.loadingQrCode = false;
        });
    },
    refreshQrCode() {
      var that = this;
      that.refreshingQrCode = true;
      this.$http
        .put(
          "services/voip/" +
            this.productId +
            "/numbers/" +
            this.value.id +
            "/qr-code"
        )
        .then((response) => {
          that.qrCode = response.data.code;
        })
        .catch((err) => {
          that.$store.commit("setSystemError", {
            msg: err.message,
            title: err.title,
          });
        })
        .finally(function () {
          that.refreshingQrCode = false;
        });
    },
  },
};
</script>

<i18n>
{
  "en": {
    "national number": "National number",
    "international number": "International number",
    "display name": "Display name",
    "language": "Language",
    "is main": "Is main",
    "signaling only": "Signaling only",
    "premium number": "Premium number",
    "premium number class": "Premium number class",
    "block size": "Block size",
    "top stop": "Top stop",
    "emergency contact": "Emergency contact",
    "SIP registrations": "SIP registrations",
    "no SIP registrations": "No SIP registrations",
    "qr code": "QR Code for iWay Telephony App",
    "qr code info": "Open the iWay Telephony app and scan the QR code.",
    "refresh qr code": "refresh QR code"
  },
  "de": {
    "national number": "Nationale Rufnummer",
    "international number": "Internationale Rufnummer",
    "display name": "Anzeigename",
    "language": "Sprache",
    "is main": "Ist Hauptnummer",
    "signaling only": "nur Signalisierung",
    "premium number": "Premiumnummer",
    "premium number class": "Premiumnummernklasse",
    "block size": "Blockgröße",
    "top stop": "Top Stop",
    "emergency contact": "Notfallkontakt",
    "SIP registrations": "SIP Registrierungen",
    "no SIP registrations": "Keine SIP Registrierungen",
    "qr code": "QR Code für iWay Telefonie App",
    "qr code info": "Öffnen Sie die iWay Telefonie App und scannen Sie den QR Code.",
    "refresh qr code": "QR Code erneuern"
  }
}
</i18n>
